module.exports = __webpack_public_path__ + "img/puzzle6.0be62267.png";